import { Container, Geometry, IDestroyOptions, Mesh, Shader, Texture, Ticker } from "pixi.js";
import Vertex from "../frames/shader/collect/outline.vert";
import Fragment from "../frames/shader/collect/outline.frag";
import { ICanvasScaler } from "../../../../../../../canvas/ICanvasScaler";
import { HourlyBonusSectionType } from "./HourlyBonusSectionType";
import { HourlyBonusResourcePackage } from "../../resources/HourlyBonusResourcePackage";

export class HourlyBonusSectionAnimation extends Container {
    private static readonly START_REST_TIME = 134;
    private static readonly END_REST_TIME = 184;

    private readonly mesh: Mesh<Shader>;

    public constructor(canvasScaler: ICanvasScaler, type: HourlyBonusSectionType, wheelResources: HourlyBonusResourcePackage) {
        super();
        let texture = Texture.EMPTY;
        let picRatio = 0;
        switch (type) {
            case HourlyBonusSectionType.left:
                texture = wheelResources.assets_views_hourly_bonus_hourly_bonus_waiting_right_png;
                picRatio = (texture.width - 4) / texture.height;
                break;
            case HourlyBonusSectionType.middle:
                texture = wheelResources.assets_views_hourly_bonus_hourly_bonus_waiting_middle_png;
                picRatio = (texture.width - 17) / texture.height;
                break;
            case HourlyBonusSectionType.right:
                texture = wheelResources.assets_views_hourly_bonus_hourly_bonus_waiting_right_png;
                picRatio = texture.width / texture.height;
                break;
        }
        const geometry = new Geometry();
        geometry.addAttribute("aVertexPosition", [-0.5, -0.5, 0.5, -0.5, 0.5, 0.5, -0.5, 0.5], 2);
        geometry.addAttribute("aUvs", [0, 0, 1, 0, 1, 1, 0, 1], 2);
        geometry.addIndex([0, 1, 2, 0, 2, 3]);
        const uniforms = {
            u_canvas_ratio: canvasScaler.referenceRatio,
            u_time: HourlyBonusSectionAnimation.START_REST_TIME,
            u_pic_ratio: picRatio,
            u_texture: texture,
            u_line_width: 0.07,
            u_scale: 1.19,
            u_pos_x: 0.08,
            u_pos_y: 0.5,
            u_color: [1, 0.78, 0],
            u_l_straight: type != HourlyBonusSectionType.left,
            u_r_straight: type != HourlyBonusSectionType.right,
            u_noise_amp: type == HourlyBonusSectionType.right ? 0.25 : 0
        };

        const shader = Shader.from(Vertex, Fragment, uniforms);
        this.mesh = new Mesh(geometry, shader);
        this.mesh.scale.set(texture.width * 2, texture.height);
        this.addChild(this.mesh);
        this.mesh.position.set(texture.width * 0.5, 0);
        this.update = this.update.bind(this);
        Ticker.shared.add(this.update);
    }

    private update(dt: number): void {
        this.mesh.shader.uniforms.u_time += dt;
        if (this.mesh.shader.uniforms.u_time >= HourlyBonusSectionAnimation.END_REST_TIME) {
            this.mesh.shader.uniforms.u_time = HourlyBonusSectionAnimation.START_REST_TIME;
        }
    }

    public async playAnimation(): Promise<void> {
        this.resetTime();
    }

    private resetTime(): void {
        this.mesh.shader.uniforms.u_time = 0;
    }

    public async setActiveColor(): Promise<void> {
        this.setOrangeColor();
    }

    private setOrangeColor(): void {
        this.mesh.shader.uniforms.u_color = [0.1, 0.9, 0.1];
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        Ticker.shared.remove(this.update);
        super.destroy(options);
    }
}